// extracted by mini-css-extract-plugin
export default {"small":"eWDezyzKk8"};